import { toFarsiNumber } from "@utils/digits";
import parse, {
  attributesToProps,
  domToReact,
  DOMNode,
  Element,
  HTMLReactParserOptions,
  Text,
} from "html-react-parser";

export function createInstructorContentParserOptions(): HTMLReactParserOptions {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      const node = domNode as Element;
      const theChildren = node.children as DOMNode[];

      if (node.attribs) {
        const props = attributesToProps(node.attribs);

        if (node.name === "a") {
          return (
            <a
              {...props}
              rel="noopener noreferrer"
              target="_blank"
              className="text-[#1e88e5]"
            >
              {domToReact(theChildren, options)}
            </a>
          );
        }

        if (node.name === "ul") {
          return (
            <ul className="list-disc mb-4 pr-10 " {...props}>
              {domToReact(theChildren, options)}
            </ul>
          );
        }

        if (node.name === "li") {
          return <li {...props}>{domToReact(theChildren, options)}</li>;
        }

        return undefined;
      }

      const text = domNode as Text;
      text.data = toFarsiNumber(text.data);
      return text;
    },
  };

  return options;
}

export function parseInstructorHtml(
  html: string,
  options: HTMLReactParserOptions
) {
  return parse(html, options);
}
